export default __webpack_public_path__ + "static/group-71-2b21be363b15978e0be439a970617812.png";